import { render } from "./PartnerRequestApprovedListItem.vue?vue&type=template&id=ec221f8c&scoped=true&ts=true"
import script from "./PartnerRequestApprovedListItem.vue?vue&type=script&lang=ts"
export * from "./PartnerRequestApprovedListItem.vue?vue&type=script&lang=ts"

import "./PartnerRequestApprovedListItem.vue?vue&type=style&index=0&id=ec221f8c&lang=scss&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec221f8c"]])

export default __exports__